export const parseNotificationContent = (content) => {
    try {
        return JSON.parse(content);
    }
    catch (error) {
        console.error('JSON parse error: ', error);
    }
};
